import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";
import { AttendanceRequest } from "./schema";
import { useTakeActionModal } from "../take-action-modal/use-action-modal";
import { Pencil } from "lucide-react";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as AttendanceRequest;

  const { onOpenChange, setAttRequestId, setOtherInfo } = useTakeActionModal();

  return (
    <>
      <Button
        size="icon"
        className="w-5 h-5"
        onMouseDown={() => {
          setOtherInfo({
            notes: originData?.notes,
            employeeName: originData?.employee,
          });
          setAttRequestId(originData?.id);
          onOpenChange(true);
        }}
      >
        <Pencil className="w-3 h-3" />
      </Button>
    </>
  );
}
